import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Video, Crown, Play, Film, Music, Mic, Star, Filter, X } from 'lucide-react';
import SEO from '../../components/SEO';

const ExploreVideos = () => {
  const subscriptionJoinLink = 'https://members.popcrownofficial.com/subscription/join';
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedVideo, setSelectedVideo] = useState(null);

  const categories = [
    { id: 'all', name: 'All Videos', icon: Video, count: 0 },
    { id: 'short-films', name: 'Short Films', icon: Film, count: 0 },
    { id: 'thriller-era', name: 'Thriller Era (1982-84)', icon: Star, count: 0 },
    { id: 'bad-era', name: 'Bad Era (1987-89)', icon: Music, count: 0 },
    { id: 'dangerous-era', name: 'Dangerous Era (1991-93)', icon: Music, count: 0 },
    { id: 'history-era', name: 'HIStory Era (1995-97)', icon: Music, count: 0 },
    { id: 'invincible-era', name: 'Invincible Era (2001)', icon: Music, count: 0 },
    { id: 'jackson5', name: 'Jackson 5 / The Jacksons', icon: Mic, count: 0 },
    { id: 'live', name: 'Live Performances', icon: Mic, count: 0 },
  ];

  const videos = [
    // SHORT FILMS - The legendary long-form music videos
    { 
      title: 'Thriller', 
      year: '1983', 
      youtubeId: 'sOnqjkJTMaA', 
      duration: '13:42',
      category: 'short-films',
      description: 'The 14-minute masterpiece that revolutionized music videos forever. Directed by John Landis.',
      featured: true
    },
    { 
      title: 'Bad', 
      year: '1987', 
      youtubeId: 'dsUXAEzaC3Q', 
      duration: '18:00',
      category: 'short-films',
      description: 'Directed by Martin Scorsese, featuring Wesley Snipes. Shot in a NYC subway station.',
      featured: true
    },
    { 
      title: 'Smooth Criminal', 
      year: '1988', 
      youtubeId: 'h_D3VFfhvs4', 
      duration: '9:24',
      category: 'short-films',
      description: 'From Moonwalker. Features the legendary anti-gravity lean and Club 30s scene.',
      featured: true
    },
    { 
      title: 'Ghosts', 
      year: '1997', 
      youtubeId: 'Xh9Cp4rd7mI', 
      duration: '4:07',
      category: 'short-films',
      description: 'Official shortened version. MJ plays multiple characters including the Maestro and Mayor.',
      featured: true
    },
    { 
      title: 'You Rock My World', 
      year: '2001', 
      youtubeId: '1-7ABIM2qjU', 
      duration: '13:25',
      category: 'short-films',
      description: 'Features Marlon Brando (his final film role) and Chris Tucker.',
      featured: true
    },
    { 
      title: 'Remember the Time', 
      year: '1992', 
      youtubeId: 'LeiFF0gvqcc', 
      duration: '9:16',
      category: 'short-films',
      description: 'Set in ancient Egypt with Eddie Murphy, Iman, and Magic Johnson.',
      featured: true
    },

    // THRILLER ERA (1982-1984)
    { 
      title: 'Billie Jean', 
      year: '1983', 
      youtubeId: 'Zi_XLOBDo_Y', 
      duration: '4:54',
      category: 'thriller-era',
      description: 'The first video by a Black artist to receive heavy rotation on MTV.',
      featured: true
    },
    { 
      title: 'Beat It', 
      year: '1983', 
      youtubeId: 'oRdxUFDoQe0', 
      duration: '5:03',
      category: 'thriller-era',
      description: 'Featured real LA gang members. Eddie Van Halen played the guitar solo.',
      featured: true
    },
    { 
      title: 'Wanna Be Startin\' Somethin\' (Lyric Video)', 
      year: '1983', 
      youtubeId: 'DsJlttdkybk', 
      duration: '6:03',
      category: 'thriller-era',
      description: 'Official lyric video. Opening track from Thriller, known for its iconic "mama-se, mama-sa" chant.'
    },
    { 
      title: 'Human Nature', 
      year: '1983', 
      youtubeId: 'ElN_4vUvTPs', 
      duration: '4:06',
      category: 'thriller-era',
      description: 'A smooth R&B ballad written by Steve Porcaro and John Bettis.'
    },
    { 
      title: 'P.Y.T. (Pretty Young Thing)', 
      year: '1983', 
      youtubeId: '1ZZQuj6htF4', 
      duration: '3:59',
      category: 'thriller-era',
      description: 'Written by James Ingram and Quincy Jones, featuring backing vocals by sisters Janet and La Toya.'
    },
    { 
      title: 'Say Say Say (with Paul McCartney)', 
      year: '1983', 
      youtubeId: 'PPEGaJ8I1GI', 
      duration: '4:57',
      category: 'thriller-era',
      description: 'Official 4K remaster. Duet with Paul McCartney from the Pipes of Peace album.'
    },

    // BAD ERA (1987-1989)
    { 
      title: 'The Way You Make Me Feel', 
      year: '1987', 
      youtubeId: 'HzZ_urpj4As', 
      duration: '6:44',
      category: 'bad-era',
      description: 'Street-themed video featuring model Tatiana Thumbtzen.'
    },
    { 
      title: 'Dirty Diana', 
      year: '1988', 
      youtubeId: 'yUi_S6YWjZw', 
      duration: '4:52',
      category: 'bad-era',
      description: 'Rock-influenced track about a dangerous groupie. Features guitarist Steve Stevens.'
    },
    { 
      title: 'Man in the Mirror', 
      year: '1988', 
      youtubeId: 'PivWY9wn5ps', 
      duration: '5:03',
      category: 'bad-era',
      description: 'Powerful anthem about self-reflection and making change. Andraé Crouch choir.'
    },
    { 
      title: 'Another Part of Me', 
      year: '1988', 
      youtubeId: '8vwHQNQ88cM', 
      duration: '4:44',
      category: 'bad-era',
      description: 'Live footage from the Bad World Tour at Wembley Stadium. Originally from Captain EO.'
    },
    { 
      title: 'Speed Demon', 
      year: '1988', 
      youtubeId: 'l039y9FaIjc', 
      duration: '10:00',
      category: 'bad-era',
      description: 'Claymation sequence from Moonwalker directed by Will Vinton. MJ as Spike the rabbit.'
    },
    { 
      title: 'Leave Me Alone', 
      year: '1989', 
      youtubeId: 'crbFmpezO4A', 
      duration: '4:37',
      category: 'bad-era',
      description: 'Grammy-winning video satirizing tabloid coverage. Innovative visual effects.'
    },
    { 
      title: 'Liberian Girl', 
      year: '1989', 
      youtubeId: 'f3V-7DEAgdc', 
      duration: '3:50',
      category: 'bad-era',
      description: 'Star-studded video with cameos from Spielberg, Dan Aykroyd, Whoopi Goldberg, and more.'
    },

    // DANGEROUS ERA (1991-1993)
    { 
      title: 'Black or White', 
      year: '1991', 
      youtubeId: 'pTFE8cirkdQ', 
      duration: '6:22',
      category: 'dangerous-era',
      description: 'Revolutionary morphing technology. Features Macaulay Culkin. Premiered to 500M viewers.',
      featured: true
    },
    { 
      title: 'In the Closet', 
      year: '1992', 
      youtubeId: '4qLY0vbrT8Q', 
      duration: '6:07',
      category: 'dangerous-era',
      description: 'Sensual video featuring supermodel Naomi Campbell. Directed by Herb Ritts.'
    },
    { 
      title: 'Jam', 
      year: '1992', 
      youtubeId: 'JbHI1yI1Ndk', 
      duration: '5:38',
      category: 'dangerous-era',
      description: 'Features Michael Jordan, Heavy D, and Kris Kross. Shot in Chicago.'
    },
    { 
      title: 'Heal the World', 
      year: '1992', 
      youtubeId: 'BWf-eARnf6U', 
      duration: '6:25',
      category: 'dangerous-era',
      description: 'Humanitarian anthem with children from around the world.'
    },
    { 
      title: 'Who Is It', 
      year: '1993', 
      youtubeId: 'ST-TebTp3vo', 
      duration: '6:35',
      category: 'dangerous-era',
      description: 'Dark cinematic video about betrayal and heartbreak. Directed by David Fincher.'
    },
    { 
      title: 'Give In to Me', 
      year: '1993', 
      youtubeId: 'LJ7qXHjxj_0', 
      duration: '5:30',
      category: 'dangerous-era',
      description: 'Rock ballad featuring Slash from Guns N\' Roses on guitar.'
    },
    { 
      title: 'Will You Be There', 
      year: '1993', 
      youtubeId: 'jQY_QL_wvQU', 
      duration: '3:38',
      category: 'dangerous-era',
      description: 'Featured in Free Willy soundtrack. Live Dangerous Tour footage with film clips.'
    },
    { 
      title: 'Gone Too Soon', 
      year: '1993', 
      youtubeId: 'IcNamirwTaY', 
      duration: '3:39',
      category: 'dangerous-era',
      description: 'Tribute to Ryan White, a young AIDS awareness activist and friend of MJ.'
    },

    // HIStory ERA (1995-1997)
    { 
      title: 'Scream (with Janet Jackson)', 
      year: '1995', 
      youtubeId: '0P4A1K4lXDo', 
      duration: '4:38',
      category: 'history-era',
      description: 'The most expensive music video ever made ($7M). Duet with sister Janet.',
      featured: true
    },
    { 
      title: 'They Don\'t Care About Us (Prison Version)', 
      year: '1996', 
      youtubeId: 't1pqi8vjTLY', 
      duration: '4:45',
      category: 'history-era',
      description: 'Controversial political statement. Directed by Spike Lee.',
      featured: true
    },
    { 
      title: 'They Don\'t Care About Us (Brazil Version)', 
      year: '1996', 
      youtubeId: 'QNJL6nfu__Q', 
      duration: '4:40',
      category: 'history-era',
      description: 'Filmed in the favelas of Rio de Janeiro with Olodum. Directed by Spike Lee.'
    },
    { 
      title: 'Earth Song', 
      year: '1995', 
      youtubeId: 'XAi3VTSdTxU', 
      duration: '6:46',
      category: 'history-era',
      description: 'Powerful environmental anthem. MJ\'s best-selling single in the UK.',
      featured: true
    },
    { 
      title: 'Childhood (Theme from Free Willy 2)', 
      year: '1995', 
      youtubeId: 'puQEcN_iI9o', 
      duration: '4:29',
      category: 'history-era',
      description: 'Personal song about MJ\'s lost childhood. Children flying in sailboats through enchanted forest.'
    },
    { 
      title: 'You Are Not Alone', 
      year: '1995', 
      youtubeId: 'pAyKJAtDNCw', 
      duration: '5:04',
      category: 'history-era',
      description: 'First song to debut at #1 on Billboard Hot 100. Written by R. Kelly.'
    },
    { 
      title: 'Stranger in Moscow', 
      year: '1996', 
      youtubeId: 'pEEMi2j6lYE', 
      duration: '5:44',
      category: 'history-era',
      description: 'Atmospheric video about isolation and loneliness, filmed in black & white.'
    },
    { 
      title: 'Blood on the Dance Floor', 
      year: '1997', 
      youtubeId: 'c3_NntYhzV4', 
      duration: '4:16',
      category: 'history-era',
      description: 'Dark and dramatic salsa club scene. Best-selling remix album of all time.'
    },
    { 
      title: 'HIStory Teaser', 
      year: '1995', 
      youtubeId: 'qw0D_KN2KN8', 
      duration: '4:02',
      category: 'history-era',
      description: 'Epic $4M promo filmed in Budapest with Hungarian soldiers and giant statue.'
    },

    // INVINCIBLE ERA (2001)
    { 
      title: 'Cry', 
      year: '2001', 
      youtubeId: 'mj3MfUR35CM', 
      duration: '4:59',
      category: 'invincible-era',
      description: 'Features diverse groups of people holding hands across California. MJ\'s final studio video.'
    },

    // JACKSON 5 / THE JACKSONS
    { 
      title: 'I Want You Back', 
      year: '1969', 
      youtubeId: 'pjCiKk-wHys', 
      duration: '3:00',
      category: 'jackson5',
      description: 'The debut single that launched the Jackson 5 to stardom at Motown.',
      featured: true
    },
    { 
      title: 'ABC', 
      year: '1970', 
      youtubeId: 'ho7796-au8U', 
      duration: '2:58',
      category: 'jackson5',
      description: 'The classic hit that knocked The Beatles off the #1 spot.'
    },
    { 
      title: 'I\'ll Be There (Lyric Video)', 
      year: '1970', 
      youtubeId: 'VRdG9vEJOKY', 
      duration: '3:58',
      category: 'jackson5',
      description: 'Official lyric video. Emotional ballad showcasing young Michael\'s incredible vocal range.'
    },
    { 
      title: 'Never Can Say Goodbye', 
      year: '1971', 
      youtubeId: 's86K-p089R8', 
      duration: '2:58',
      category: 'jackson5',
      description: 'Soulful classic written by Clifton Davis.'
    },
    { 
      title: 'Dancing Machine (Live Mexico City 1975)', 
      year: '1974', 
      youtubeId: '73DzcrfVNNk', 
      duration: '6:42',
      category: 'jackson5',
      description: 'Official HD live performance. The song that first featured Michael\'s Robot dance.'
    },
    { 
      title: 'Blame It on the Boogie', 
      year: '1978', 
      youtubeId: 'nqxVMLVe62U', 
      duration: '3:26',
      category: 'jackson5',
      description: 'First single as The Jacksons on Epic Records. Disco classic.'
    },
    { 
      title: 'Shake Your Body (Down to the Ground)', 
      year: '1979', 
      youtubeId: 'kldVOhKe4rg', 
      duration: '7:45',
      category: 'jackson5',
      description: 'Live performance from TopPop 1979. Written by Michael and Randy.'
    },
    { 
      title: 'Can You Feel It', 
      year: '1981', 
      youtubeId: 'lrKZNqIR2U0', 
      duration: '9:38',
      category: 'jackson5',
      description: 'Official video "The Triumph". Groundbreaking visual effects, voted one of MTV\'s 100 best videos.'
    },

    // LIVE PERFORMANCES
    { 
      title: 'Billie Jean - Motown 25 (1983)', 
      year: '1983', 
      youtubeId: 'g3t9-kf7ZNA', 
      duration: '4:57',
      category: 'live',
      description: 'THE performance that changed everything. First moonwalk on TV.',
      featured: true
    },
    { 
      title: 'Super Bowl XXVII Halftime (1993)', 
      year: '1993', 
      youtubeId: '61E40Yv0C-U', 
      duration: '12:00',
      category: 'live',
      description: 'The performance that set the standard for all Super Bowl halftimes. 133 million viewers.',
      featured: true
    },
    { 
      title: 'Dangerous - Live Munich (1997)', 
      year: '1997', 
      youtubeId: 'SOlQDqaVY-4', 
      duration: '2:04:00',
      category: 'live',
      description: 'Full HIStory World Tour concert. Dangerous starts at 1:06:24.'
    },
    { 
      title: 'Smooth Criminal - Live Bucharest (1992)', 
      year: '1992', 
      youtubeId: 'vuNGomCgsYE', 
      duration: '6:13',
      category: 'live',
      description: '4K remastered Dangerous Tour. Features the famous anti-gravity lean.'
    },
    { 
      title: 'Billie Jean - Live Munich (1997)', 
      year: '1997', 
      youtubeId: 'VE8Bcb3eAsA', 
      duration: '10:40',
      category: 'live',
      description: '2025 4K remaster. Legendary HIStory Tour performance with light-up floor.'
    },
    { 
      title: 'Earth Song - Live Munich (1997)', 
      year: '1997', 
      youtubeId: 'I4neP0D1W6k', 
      duration: '8:00',
      category: 'live',
      description: '4K upscale from HIStory Tour. Emotional environmental anthem with dramatic staging.'
    },
    { 
      title: 'Beat It - Live Wembley (1988)', 
      year: '1988', 
      youtubeId: '7mYMH6Iyq8A', 
      duration: '6:36',
      category: 'live',
      description: '4K Ultra HD from Bad World Tour at Wembley. Princess Diana attended this show.'
    },
    { 
      title: 'Wanna Be Startin\' Somethin\' - Live Munich (1997)', 
      year: '1997', 
      youtubeId: 'Ltv3NPQVnDo', 
      duration: '6:22',
      category: 'live',
      description: 'High energy HIStory Tour performance remastered in 4K.'
    },
    { 
      title: 'Man in the Mirror - Grammy Awards (1988)', 
      year: '1988', 
      youtubeId: '3yg7Srt_too', 
      duration: '7:00',
      category: 'live',
      description: '4K remastered Grammy performance. Brought the audience to their feet.'
    },
  ];

  // Update category counts
  categories.forEach(cat => {
    if (cat.id === 'all') {
      cat.count = videos.length;
    } else {
      cat.count = videos.filter(v => v.category === cat.id).length;
    }
  });

  const filteredVideos = activeCategory === 'all' 
    ? videos 
    : videos.filter(v => v.category === activeCategory);

  const featuredVideos = videos.filter(v => v.featured);

  const openVideo = (video) => {
    setSelectedVideo(video);
    document.body.style.overflow = 'hidden';
  };

  const closeVideo = () => {
    setSelectedVideo(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="min-h-screen pt-20" data-testid="explore-videos-page">
      <SEO title="Michael Jackson Music Videos — Iconic Short Films & Performances | PopCrown" description="Watch Michael Jackson's legendary music videos. From Thriller and Beat It to Smooth Criminal, Scream, and They Don't Care About Us. The greatest visual artist in music history." keywords="Michael Jackson music videos, MJ short films, Thriller video, Beat It video, Smooth Criminal video, Billie Jean video, Scream video, Black or White video, Remember the Time video, They Don't Care About Us" canonical="/explore/videos" />
      {/* Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: 'rgba(0, 0, 0, 0.95)' }}
          onClick={closeVideo}
        >
          <div 
            className="relative w-full max-w-5xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeVideo}
              className="absolute -top-12 right-0 text-white hover:text-[#E10600] transition-colors flex items-center gap-2"
              data-testid="close-video-modal"
            >
              <span>Close</span>
              <X className="w-6 h-6" />
            </button>
            
            {/* Video Title */}
            <h3 className="text-white text-xl font-bold mb-4">
              {selectedVideo.title} <span className="text-[#E10600]">({selectedVideo.year})</span>
            </h3>
            
            {/* Embedded YouTube Player */}
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute inset-0 w-full h-full rounded-lg"
                src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}?autoplay=1&rel=0`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            
            {/* Video Description */}
            <p className="text-gray-400 mt-4">{selectedVideo.description}</p>
          </div>
        </div>
      )}

      {/* Header */}
      <section className="py-12" style={{ background: 'linear-gradient(180deg, #1a1a1a 0%, #000 100%)' }}>
        <div className="container mx-auto px-4">
          <Link to="/explore" className="inline-flex items-center gap-2 text-[#E10600] hover:text-white transition-colors mb-6">
            <ArrowLeft className="w-5 h-5" />
            Back to Explore
          </Link>
          <div className="flex items-center gap-4">
            <Video className="w-12 h-12 text-[#FF0000]" />
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-white">
                <span className="thriller-text">Videos</span>
              </h1>
              <p className="text-gray-400">{videos.length} music videos, short films, and live performances</p>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-6 bg-black border-b border-gray-800 sticky top-16 z-40">
        <div className="container mx-auto px-4">
          <div className="flex items-center gap-2 mb-3">
            <Filter className="w-4 h-4 text-[#E10600]" />
            <span className="text-sm text-gray-400">Filter by category:</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${
                  activeCategory === cat.id 
                    ? 'bg-[#E10600] text-black' 
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
                data-testid={`filter-${cat.id}`}
              >
                {cat.name} ({cat.count})
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Section (only show when viewing "All") */}
      {activeCategory === 'all' && (
        <section className="py-12" style={{ background: 'linear-gradient(180deg, #000 0%, #1a1a1a 100%)' }}>
          <div className="container mx-auto px-4">
            <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
              <Star className="w-6 h-6 text-[#E10600]" />
              Featured Must-Watch
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {featuredVideos.slice(0, 6).map((video, index) => (
                <button
                  key={index}
                  onClick={() => openVideo(video)}
                  className="group relative rounded-lg overflow-hidden aspect-video text-left"
                >
                  <img
                    src={`https://img.youtube.com/vi/${video.youtubeId}/mqdefault.jpg`}
                    alt={`${video.title} - Michael Jackson`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-2">
                    <h4 className="text-white text-sm font-bold truncate">{video.title}</h4>
                    <span className="text-[#E10600] text-xs">{video.year}</span>
                  </div>
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <Play className="w-10 h-10 text-white" fill="white" />
                  </div>
                </button>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Videos Grid */}
      <section className="py-12" style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #FFF5F5 100%)' }}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-black">
              {activeCategory === 'all' ? 'All Videos' : categories.find(c => c.id === activeCategory)?.name}
              <span className="text-gray-500 font-normal ml-2">({filteredVideos.length})</span>
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredVideos.map((video, index) => (
              <button
                key={index}
                onClick={() => openVideo(video)}
                className="group rounded-xl overflow-hidden transition-all duration-300 hover:transform hover:scale-102 hover:shadow-xl text-left"
                style={{
                  background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
                  border: '2px solid rgba(255, 0, 0, 0.2)'
                }}
                data-testid={`video-${video.youtubeId}`}
              >
                {/* Thumbnail */}
                <div className="relative aspect-video">
                  <img
                    src={`https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`}
                    alt={`${video.title} - Michael Jackson music video ${video.year} - King of Pop`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-16 h-16 rounded-full bg-[#FF0000] flex items-center justify-center">
                      <Play className="w-8 h-8 text-white ml-1" fill="white" />
                    </div>
                  </div>
                  {/* Duration Badge */}
                  {video.duration && (
                    <span className="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-2 py-1 rounded">
                      {video.duration}
                    </span>
                  )}
                  {/* Featured Badge */}
                  {video.featured && (
                    <span className="absolute top-2 left-2 bg-[#E10600] text-black text-xs px-2 py-1 rounded font-bold flex items-center gap-1">
                      <Star className="w-3 h-3" /> ESSENTIAL
                    </span>
                  )}
                </div>
                
                {/* Video Info */}
                <div className="p-4">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-lg font-bold text-white group-hover:text-[#E10600] transition-colors truncate">
                      {video.title}
                    </h3>
                    <span className="text-[#E10600] font-semibold text-sm shrink-0 ml-2">{video.year}</span>
                  </div>
                  <p className="text-gray-400 text-sm line-clamp-2">{video.description}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-4xl font-bold text-[#E10600]">{videos.length}</div>
              <div className="text-gray-400">Total Videos</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#E10600]">{videos.filter(v => v.category === 'short-films').length}</div>
              <div className="text-gray-400">Short Films</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#E10600]">5</div>
              <div className="text-gray-400">Music Eras</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#E10600]">{videos.filter(v => v.category === 'live').length}</div>
              <div className="text-gray-400">Live Performances</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-16" style={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #000 100%)' }}>
        <div className="container mx-auto px-4 text-center">
          <img src="/popcrown-crown-red.png" alt="" aria-hidden="true" className="w-10 h-10 mx-auto mb-4 object-contain" />
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Want More? Join the <span className="thriller-text">Community</span>
          </h2>
          <p className="text-gray-400 mb-6 max-w-xl mx-auto">
            Access exclusive discussions about MJ's music videos, share your favorite moments, and connect with fans worldwide.
          </p>
          <a 
            href={subscriptionJoinLink} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-gold inline-block"
            data-testid="join-community-cta"
          >
            Become a Member
          </a>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-6 bg-black border-t border-gray-800">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-500 text-xs">
            All videos are owned by their respective copyright holders and are embedded via YouTube. 
            PopCrown is not affiliated with Sony Music, the Michael Jackson Estate, or any rights holders.
          </p>
        </div>
      </section>
    </div>
  );
};

export default ExploreVideos;
